import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from './Context/UserContext';
import { Table, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";
import "../styles/ViewAllVendorsPO.css";
import { Link } from "react-router-dom";
import profileImg from "../assets/logo.png";
import VendorInfoTabs from "./VendorInfoTabs";
import DashboardLayout from "../../src/components/DashboardLayout";

const ViewAllVendorsPO = () => {
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [activeTab, setActiveTab] = useState("details");
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [subTab, setSubTab] = useState("details");
    const [approvalStatusError, setApprovalStatusError] = useState("");
    const [rejectionSendToError, setRejectionSendToError] = useState("");
    const [isSaved, setIsSaved] = useState(false);
    const [departmentHeadError, setDepartmentHeadError] = useState("");
    const [departmentTypeError, setDepartmentTypeError] = useState("");
    const [status, setStatus] = useState("");
    const [comments, setComments] = useState("");
    const [deptId, setDeptId] = useState("");
    const [headId, setHeadId] = useState("");
    const [departments, setDepartments] = useState([]);
    const [departmentHeads, setDepartmentHeads] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [approverId, setApproverId] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchInput, setSearchInput] = useState(""); // raw field value (debounced into searchTerm)
    const [selectedStatus, setSelectedStatus] = useState("Pending");
    const [users, setUsers] = useState([]);
    const [approvalDetails, setApprovalDetails] = useState(null);
    const [showSaveBtn, setShowSaveBtn] = useState(true);
    const [approvalHistory, setApprovalHistory] = useState([]);
    const [verifiers, setVerifiers] = useState([]); // list of verifier users
    const [selectedVerifier, setSelectedVerifier] = useState(""); // currently selected verifier
    const [verifierError, setVerifierError] = useState(""); // validation error
    
    useEffect(() => {
        const fetchApproverId = async () => {
            try {
                const res = await axios.get("/api/approvalstatus/get-approver-id");
                console.log("API response:", res.data);
                const id = res.data.EMPID || res.data.empid;
                console.log("Approver ID fetched:", id);

                setApproverId(id);
            } catch (error) {
                console.error("Failed to fetch approver ID:", error);
            }
        };
        fetchApproverId();
    }, []);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const res = await axios.get("/department/departments"); //  Corrected URL
                console.log("Departments fetched:", res.data);
                setDepartments(res.data);
            } catch (err) {
                console.error("Failed to load departments", err);
            }
        };
        fetchDepartments();
    }, []);

    useEffect(() => {
        if (!selectedVendor?.departmentType) {
            setDepartmentHeads([]);
            return;
        }

        axios
            .get(`/department/department-heads/${selectedVendor.departmentType}`)
            .then((res) => {
                setDepartmentHeads(res.data);
                setSelectedVendor((prev) => {
                    const valid = res.data.some(
                        (head) => String(head.empId) === String(prev.departmentHead)
                    );
                    return valid ? prev : { ...prev, departmentHead: "" };
                });
            })
            .catch((err) => console.error("Failed to load department heads", err));
    }, [selectedVendor?.departmentType]);

    useEffect(() => {
        if (!selectedVendor?.departmentType) {
            setVerifiers([]);
            setSelectedVerifier("");
            return;
        }

        axios
            .get(`/department/verifiers/${selectedVendor.departmentType}`)
            .then(res => {
                console.log("Verifiers fetched:", res.data); // ✅ debug
                setVerifiers(res.data);
                setSelectedVerifier(prev => {
                    const valid = res.data.some(v => String(v.empId) === String(prev));
                    return valid ? prev : "";
                });
            })
            .catch(err => console.error("Failed to fetch verifiers", err));
    }, [selectedVendor?.departmentType]); 
    const getStatusId = (status) => {
        switch (status) {
            case "Approved": return 1;
            case "Rejected": return 2;
            case "Pending": return 3;
            case "All": return 0; // 👈 Show all vendors
            default: return 0;
        }
    };
    const mapBackendStatusToUI = (status) => {
        if (status === 4) return "Approved";
        if (status === 3) return "Rejected";
        return "Pending";
    };
    const isReadOnly = selectedVendor?.approvalStatus === "Approved"
        || selectedVendor?.approvalStatus === "Rejected";

    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const statusId = getStatusId(selectedStatus);
                const url = statusId
                    ? `/api/vendordetails/details?statusId=${statusId}`
                    : "/api/vendordetails/details";

                console.log("Fetching vendors from:", url);
                const vendorResponse = await axios.get(url);
                setVendors(vendorResponse.data);
            } catch (err) {
                console.error("Error fetching vendors:", err);
                setVendors([]);
            }
        };

        fetchData();
    }, [selectedStatus]);


    useEffect(() => {
        console.log("Selected Vendor:", selectedVendor);

        if (selectedVendor && selectedVendor.userId) {
            axios
               
                .get(`/api/approvalstatus/status/${selectedVendor.id}`)
                .then(response => {
                    console.log("Approval History Data:", response.data);
                    setUsers(response.data || []);
                })
                .catch(error => {
                    console.error("Error fetching approval status:", error);
                });
        }
    }, [selectedVendor]);

    // Debounce the search field (300ms) → commits into searchTerm used for filtering
    useEffect(() => {
        const handle = setTimeout(() => {
            setSearchTerm(searchInput);
            setCurrentPage(1); // reset to first page when the search changes
        }, 300);
        return () => clearTimeout(handle);
    }, [searchInput]);

    const usersPerPage = 6; // Only 6 users per page
    const vendorsPerPage = 6;

    const filteredVendors = vendors.filter(vendor =>
        vendor.nameOfCompany?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const startIndex = (currentPage - 1) * vendorsPerPage;
    const endIndex = startIndex + vendorsPerPage;
    // Pagination must reflect the *filtered* result set, not the full list.
    const totalPages = Math.max(1, Math.ceil(filteredVendors.length / vendorsPerPage));
    /* const vendorsForPage = vendors.slice(startIndex, startIndex + vendorsPerPage);*/
    const vendorsForPage = filteredVendors.slice(startIndex, endIndex);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "Invalid Date";
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
    };
    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    console.log("Clicked user:", user);
    const handleReviewClick = (index) => {

        const vendor = vendors[index]; //  Declare vendor first
        console.log("Clicked vendor:", vendor); //  Helps confirm structure
        console.log("Clicked vendor full object:", vendor); // <-- Add it here

        setSelectedVendor({
            ...vendor,
            userId: vendor.userId || vendor.UserId || vendor.userid || vendor.id || null, //  Ensure correct userId
            index
        });
        setShowModal(true);
        setIsEditing(false);
        setActiveTab("history");
    };
    
    useEffect(() => {
        if (!selectedVendor?.id || !approverId || !showModal) return;

        const fetchVendorApprovalDetails = async () => {
            try {
                const res = await axios.get(
                    "/api/approvalstatus/vendor-latest-approval",
                    { params: { vendorId: selectedVendor.id, approvalId: approverId } }
                );

                const data = res?.data || {};
                const deptId = data.dept_ID || "";
                const deptHeadId = data.dept_headID || "";
                const verifierId = data.verifierID || "";
                const approvalStatus = data.approvalStatus;
                const comments = data.approvalComments || "";

                // ✅ Map backend → UI status safely
                const backendStatus =
                    approvalStatus === 4
                        ? "Approved"
                        : approvalStatus === 3
                            ? "Rejected"
                            : "Pending";

                // ✅ Single source of truth for UI locking
                const isReadOnly = backendStatus !== "Pending";

                setSelectedVendor(prev => ({
                    ...prev,

                    // ✅ ALWAYS defined
                    originalStatus: backendStatus,
                    isReadOnly,
                    // ✅ Preserve user selections for Pending
                    departmentType: isReadOnly ? deptId : prev.departmentType || "",
                    departmentHead: isReadOnly ? deptHeadId : prev.departmentHead || "",
                    verifierId: isReadOnly ? verifierId : prev.verifierId || "",
                    // ✅ Do NOT blank approvalStatus for Pending
                    approvalStatus: isReadOnly ? backendStatus : prev.approvalStatus || "",
                    // ✅ Preserve comments for Pending
                    comments: isReadOnly ? comments : prev.comments || "",
                }));
            } catch (err) {
                console.error("Error fetching vendor approval details:", err);
            }
        };
        fetchVendorApprovalDetails();
    }, [selectedVendor?.id, approverId, showModal]);

    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };

    const handleSave = async () => {
        if (!selectedVendor?.id) {
            console.error("Missing vendor ID");
            return;
        }

        let isValid = true;
        // Reset errors
        setApprovalStatusError("");
        setCommentError("");
        setDepartmentHeadError("");
        setDepartmentTypeError("");
        setVerifierError("");

        // Validation
        if (
            selectedVendor?.approvalStatus !== "Approved" &&
            selectedVendor?.approvalStatus !== "Rejected"
        ) {
            setApprovalStatusError("Approval status is required");
            isValid = false;
        }

        if (!selectedVendor?.comments?.trim()) {
            setCommentError("Comment is required");
            isValid = false;
        }

        if (!selectedVendor?.departmentType) {
            setDepartmentTypeError("Department type is required");
            isValid = false;
        }

        if (!selectedVendor?.departmentHead) {
            setDepartmentHeadError("Department head is required");
            isValid = false;
        }

        if (!selectedVerifier && !selectedVendor?.verifierId) {
            setVerifierError("Verifier is required");
            isValid = false;
        }

        if (!isValid) return;

        const statusValue =
            selectedVendor.approvalStatus === "Approved" ? 4 :
                selectedVendor.approvalStatus === "Rejected" ? 3 : null;

        // Payload
        const payload = {
            VendorId: Number(selectedVendor.id),
            approvalStatus: statusValue,
            DeptId: selectedVendor.departmentType,
            HeadId: selectedVendor.departmentHead,
            VerifierId: (selectedVerifier || selectedVendor.verifierId || "").toString(),
            Comments: selectedVendor.comments || "",
            ApproverId: Number(approverId)
        };

        console.log("Payload to send:", payload);

        try {
            const response = await axios.post(
                "/api/approvalstatus/approve",
                payload
            );

            console.log("Server response:", response);

            if (response.status === 200) {
                alert(response.data.message || "Approval saved successfully.");

                // Update UI
                // Remove vendor from current filtered list
                setVendors(prev => prev.filter(v => v.id !== selectedVendor.id));

                setShowModal(false);
                setIsEditing(false);
            } else {
                alert("Failed to save approval.");
            }
        } catch (error) {
            console.error("Error saving approval:", error);
        }
    };


    const handleSort = (column) => {
        const sortedVendors = [...vendors].sort((a, b) => {
            let valueA, valueB;

            if (column === "approvalStatus") {
                valueA = a.approvalStatus?.toLowerCase() || "";
                valueB = b.approvalStatus?.toLowerCase() || "";
            }

            if (sortOrder === "asc") {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });

        setVendors(sortedVendors);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        setSortBy(column);
    };

    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };

    return (
        <DashboardLayout>
        <div className="vendor-registration-details">

                    <Container>
                    <h2 className="page-title" style={{ marginTop: 0, marginBottom: '15px', color: '#0a4275', paddingTop: '10px' }}>
                        Vendors Details
                    </h2>
                    <div className="vendor-toolbar">
                        {/* 🔹 Search Box — Left Side */}
                        <div className="vendor-toolbar-search">
                            <div className="vendor-search-box">
                                <span className="vendor-search-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="11" cy="11" r="8" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                                    </svg>
                                </span>
                                <Input
                                    type="text"
                                    placeholder="Search by Company Name..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    aria-label="Search by company name"
                                    className="vendor-search-input"
                                />
                                {searchInput && (
                                    <button
                                        type="button"
                                        className="vendor-search-clear"
                                        aria-label="Clear search"
                                        onClick={() => setSearchInput("")}
                                    >
                                        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* 🔹 Approved Status Dropdown — Right Side */}
                        <div className="vendor-status-filter">
                            <label className="vendor-status-label">
                                Approved Status:
                            </label>
                            <Input
                                type="select"
                                className="vendor-status-select"
                                value={selectedStatus}
                                onChange={(e) => {
                                    setSelectedStatus(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="All">All</option>
                                <option value="Approved">Approved</option>
                                <option value="Rejected">Rejected</option>
                                <option value="Pending">Pending</option>
                            </Input>
                        </div>
                    </div>
                    {searchTerm && vendorsForPage.length === 0 && (
                        <div
                            style={{
                                color: "red",
                                fontWeight: "500",
                                marginBottom: "10px",
                                textAlign: "left", // under search box
                            }}
                        >
                            Company Name not found
                        </div>
                    )}
                        <div className="list-table-scroll">
                        <Table bordered className="vendor-table vendor-table-po">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Company Name</th>
                                    <th>Contact Person</th>
                                    <th>Nature of Supply</th>
                                    <th>MSME</th>
                                    <th>PAN Number</th>
                                    <th>GST Number</th>
                                    <th>HSN/SAC Code</th>
                                    <th onClick={() => handleSort("approvalStatus")} style={{ cursor: "pointer" }}>
                                        Approval Status {sortBy === "approvalStatus"
                                            ? (sortOrder === "asc" ? "▲" : "▼")
                                            : "⇅"}
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                        <tbody>
                            {vendorsForPage.length === 0 ? (
                                <tr><td colSpan="10">No pending vendors found.</td></tr>
                            ) : (
                                vendorsForPage.map((vendor, index) => (
                                    <tr key={vendor.vendorCode || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{vendor.nameOfCompany}</td>
                                        <td>{vendor.contactPersonName || "N/A"}</td>
                                        <td>{vendor.natureOfSupply}</td>
                                        <td>{vendor.msmeNo || "N/A"}</td>
                                        <td>{vendor.pan || "N/A"}</td>
                                        <td>{vendor.gst || "N/A"}</td>
                                        <td>{vendor.hsNsacCode || "N/A"}</td>
                                        <td>{vendor.approvalStatus || "N/A"}</td>
                                        <td>
                                            <button className="review-btn" onClick={() => handleReviewClick(startIndex + index)}>
                                                Review
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        </Table>
                        </div>

                        <div className="pagination">
                            <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                            <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                            <span className="page-info">Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                            <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                        </div>
                    </Container>

                    <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                        <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                        <div className="tabs1">
                            <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>Vendor Approval History</span>
                            <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                            <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Approve/Reject</span>
                        </div>
                        <ModalBody>

                            {activeTab === "history" && selectedVendor && (
                                <div className="history-container">
                                    {users.length === 0 ? (
                                        <div className="history-empty-state">
                                            <div className="history-empty-icon" aria-hidden="true">
                                                <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                                                    <circle cx="12" cy="12" r="9" />
                                                    <polyline points="12 7 12 12 15 14" />
                                                </svg>
                                            </div>
                                            <h4 className="history-empty-title">No Approval History</h4>
                                            <p className="history-empty-text">
                                                This vendor has not yet gone through any approval stages.
                                            </p>
                                        </div>
                                    ) : (
                                    <Table bordered className="history-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Approval Status</th>
                                                <th>Approver Name</th>
                                                <th>Date</th>
                                                <th>Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length > 0 ? (
                                                users.map((user, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{user.approvalStatus || "N/A"}</td>
                                                        <td>{user.approvalName || "N/A"}</td>
                                                       
                                                        <td>
                                                            {user.createDate
                                                                ? (() => {
                                                                    const date = new Date(user.createDate);
                                                                    const day = String(date.getDate()).padStart(2, "0");
                                                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                                                    const year = date.getFullYear();
                                                                    const hours = String(date.getHours()).padStart(2, "0");
                                                                    const minutes = String(date.getMinutes()).padStart(2, "0");
                                                                    const seconds = String(date.getSeconds()).padStart(2, "0");

                                                                    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
                                                                })()
                                                                : "N/A"}
                                                        </td>

                                                        <td>{user.comments || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : null}

                                        </tbody>
                                    </Table>
                                    )}
                                </div>
                            )}
                            {activeTab === "info" && selectedVendor && (
                                <VendorInfoTabs
                                    selectedVendor={selectedVendor}
                                    isEditing={isEditing}
                                    setIsEditing={setIsEditing}
                                    handleInputChange={handleInputChange}
                                    subTab={subTab}
                                    setSubTab={setSubTab}
                                    type="vendor"
                                />
                            )}
                            {activeTab === "details" && selectedVendor && (
                                <div className="details-container">
                                    <>
                                        <Table bordered className="info-table1">
                                            <tbody>
                                                <tr>
                                                    <th>Name of Company:</th>
                                                <td>{selectedVendor?.nameOfCompany || "N/A"}</td>
                                                </tr>
                                            <tr>
                                               
                                                <th>Department Type:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.departmentType || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                departmentType: e.target.value, // ✅ FIX
                                                            });
                                                            setDepartmentTypeError("");
                                                        }}
                                                        disabled={selectedVendor?.isReadOnly}
                                                    >
                                                        <option value="">Select</option>
                                                        {departments.map((dept) => (
                                                            <option key={dept.id} value={String(dept.id)}>
                                                                {dept.type}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                    {!selectedVendor?.isReadOnly && departmentTypeError && (
                                                        <div className="text-danger">{departmentTypeError}</div>
                                                    )}
                                                </td>

                                                <th>Department Head:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVendor?.departmentHead || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({
                                                                ...selectedVendor,
                                                                departmentHead: String(e.target.value), // ✅ FIX
                                                            });
                                                            setDepartmentHeadError("");
                                                        }}
                                                        disabled={selectedVendor?.isReadOnly}
                                                    >
                                                        <option value="">Select</option>
                                                        {departmentHeads.map((head) => (
                                           
                                                            <option key={head.empId} value={String(head.empId)}>
                                                                {head.userName}
                                                            </option>
                                                        ))}
                                                    </Input>

                                                    {!selectedVendor?.isReadOnly && departmentHeadError && (
                                                        <div className="text-danger">{departmentHeadError}</div>
                                                    )}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th>Verifier Name:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="select"
                                                        className="full-width-dropdown"
                                                        value={selectedVerifier || selectedVendor?.verifierId || ""}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setSelectedVerifier(value);
                                                            setVerifierError("");
                                                            setSelectedVendor(prev => ({
                                                                ...(prev || {}),
                                                                verifierId: value
                                                            }));
                                                        }}
                                                        disabled={selectedVendor?.isReadOnly}
                                                    >
                                                        <option value="">Select Verifier</option>
                                                        {verifiers.length > 0
                                                            ? verifiers.map(v => (
                                                                <option key={v.empId} value={v.empId}>
                                                                    {v.userName}
                                                                </option>
                                                            ))
                                                            : <option disabled>No verifiers available</option>
                                                        }
                                                    </Input>
                                                    {!selectedVendor?.isReadOnly && verifierError && (
                                                        <div className="text-danger">{verifierError}</div>
                                                    )}
                                                </td>
                                            </tr>

                                            <tr>
                                                <th>Approval Status:<span className="required-field">*</span></th>
                                                    
                                                <td>
                                                    {selectedVendor?.approvalStatus ===
                                                        "Approved by PO, Pending from Dept Head" ? (
                                                        <div>Approved</div>
                                                    ) : (
                                                        <Input
                                                            type="select"
                                                            className="full-width-dropdown"
                                                            disabled={selectedVendor?.isReadOnly}
                                                            value={selectedVendor?.approvalStatus || ""}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSelectedVendor(prev => ({
                                                                    ...prev,
                                                                    approvalStatus: value
                                                                }));
                                                                setApprovalStatusError("");
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Approved">Approved</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </Input>
                                                    )}

                                                    {!selectedVendor?.isReadOnly && approvalStatusError && (
                                                        <div className="text-danger">{approvalStatusError}</div>
                                                    )}
                                                </td>


                                                <th>Comments:<span className="required-field">*</span></th>
                                                <td>
                                                    <Input
                                                        type="textarea"
                                                        value={selectedVendor?.comments || ""}
                                                        onChange={(e) => {
                                                            setSelectedVendor({ ...selectedVendor, comments: e.target.value });
                                                            setCommentError("");
                                                        }}
                                                        disabled={selectedVendor?.isReadOnly} // ✅ disables textarea if read-only
                                                        placeholder="Enter your comment..."
                                                    />
                                                    {!selectedVendor?.isReadOnly && commentError && (
                                                        <div className="text-danger">{commentError}</div>
                                                    )}
                                                </td>
                                                </tr>
                                            </tbody>

                                        </Table>
                                    <ModalFooter>
                                        {showSaveBtn && !selectedVendor?.isReadOnly && (
                                            <Button color="success" onClick={handleSave}>
                                                Save
                                            </Button>
                                        )}
                                        <Button color="danger" onClick={() => setShowModal(false)}>Close</Button>
                                    </ModalFooter>
                                 </>

                                </div>
                            )}
                        </ModalBody>
                    </Modal>
            </div>
        </DashboardLayout>
    );
};
export default ViewAllVendorsPO;